import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { User } from '../types';

type Role = User['role'];

interface RoleRouteProps {
  allow: Role[];
  children: React.ReactElement;
}

/** Redireciona para / se o papel do usuário não estiver em `allow`. Use dentro de PrivateRoute. */
const RoleRoute: React.FC<RoleRouteProps> = ({ allow, children }) => {
  const ctx = useContext(AuthContext);
  const u = ctx?.user;
  if (!u) {
    return <Navigate to="/login" replace />;
  }
  if (!allow.includes(u.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default RoleRoute;
